import http from '@utils/http';

export const getAttendance = (params = {}) =>
    http.get('/hr/attendance', { params }).then((res) => {
        const payload = res.data ?? {};
        let list = payload.data ?? payload;
        if (list && typeof list === 'object' && !Array.isArray(list) && Array.isArray(list.data)) {
            list = list.data;
        }
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: payload.total ?? data.length,
            page: payload.page ?? 1,
            limit: payload.limit ?? 10,
            totalPages: payload.totalPages ?? 1,
            presentCount: payload.presentCount ?? 0,
            absentCount: payload.absentCount ?? 0,
        };
    });

export const getEmployeeAttendanceSummary = (userId, params = {}) =>
    http.get(`/hr/attendance/employee/${userId}/summary`, { params }).then((res) => res.data?.data ?? res.data);

export const createAttendance = (data) =>
    http.post('/hr/attendance', data).then((res) => res.data?.data ?? res.data);

export const updateAttendance = (id, data) =>
    http.put(`/hr/attendance/${id}`, data).then((res) => res.data?.data ?? res.data);

export const deleteAttendance = (id) =>
    http.delete(`/hr/attendance/${id}`).then((res) => res.data?.data ?? res.data);

export const getHolidays = (params = {}) =>
    http.get('/hr/holidays', { params }).then((res) => res.data?.data ?? res.data);

export const getUpcomingEvents = (params = {}) =>
    http.get('/hr/events/upcoming', { params }).then((res) => res.data?.data ?? res.data);

export const createHoliday = (data) =>
    http.post('/hr/holidays', data).then((res) => res.data?.data ?? res.data);

export const updateHoliday = (id, data) =>
    http.put(`/hr/holidays/${id}`, data).then((res) => res.data?.data ?? res.data);

export const deleteHoliday = (id) =>
    http.delete(`/hr/holidays/${id}`).then((res) => res.data?.data ?? res.data);
